import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import type {
  CreateBclProductRequestDto,
  CreateBclProductResponseDto
} from "../../dtos/bcl-product-dto";
import { ProductService } from "../../services/product-service";

type UsePostCreateBclProductMutationParams = {
  options?: UseMutationOptions<
    CreateBclProductResponseDto,
    unknown,
    CreateBclProductRequestDto
  >;
};

export const usePostCreateBclProductMutation = ({
  options
}: UsePostCreateBclProductMutationParams = {}) => {
  return useMutation({
    mutationFn: async (payload) => {
      return await ProductService.createBclProduct({ payload });
    },
    ...options
  });
};
